import WarningIcon from '../svgIcons/WarningIcon';

export const formErrorMessage = (msg) => (
  <span className="text text-danger d-flex align-items-center">
    <WarningIcon className="me-1" />
    {msg ?? 'Warning'}
  </span>
);
